import React from 'react';
import { BlockWrapper } from '../Preview';
import { generateCss, generateEvent, generateStyle } from '../../functions/sortableFunctions';
const Ternary = ({ block, ...props }: any): any => {
    try {
        return (
            React.createElement(
                block?.data?.type ?? "div",
                {
                    id: block.id,
                    style: generateStyle({
                        props: {
                            ...props,
                            block
                        }
                    }),
                    className: generateCss({
                        props: {
                            ...props,
                            block: block
                        },
                    }),
                    onClick: block.events?.onClick ? async (e: any) => {
                        await generateEvent({
                            props: {
                                ...props,
                                block: block
                            },
                            e: e,
                            event: "onClick"
                        });
                    } : null,
                    onDoubleClick: block.events?.onDoubleClick ? async (e: any) => {
                        await generateEvent({
                            props: {
                                ...props,
                                block: block
                            },
                            e: e,
                            event: "onDoubleClick"
                        });
                    } : null,
                    onContextMenu: block.events?.onContextMenu ? async (e: any) => {
                        await generateEvent({
                            props: {
                                ...props,
                                block: block
                            },
                            e: e,
                            event: "onContextMenu"
                        });
                    } : null,
                    onMouseOver: block.events?.onMouseOver ? async (e: any) => {
                        await generateEvent({
                            props: {
                                ...props,
                                block: block
                            },
                            e: e,
                            event: "onMouseOver"
                        });
                    } : null,
                    onMouseLeave: block.events?.onMouseLeave ? async (e: any) => {
                        await generateEvent({
                            props: {
                                ...props,
                                block: block
                            },
                            e: e,
                            event: "onMouseLeave"
                        });
                    } : null
                },
                eval(block?.data?.condition) ?
                    <BlockWrapper  {...props} block={block?.children[0]} />
                    : <BlockWrapper  {...props} block={block?.children[1]} />
            )
        )
    } catch (error) {
        console.log(error);
        return null;
    }
}
export default Ternary; 